import { Vector2 } from 'three'

export enum ATTACK_TYPES {
  PUNCH = 'PUNCH',
  SWORD = 'SWORD',
  FIREBALL = 'FIREBALL',
}

export const getRangeByAttack = (attack: string, coords: Vector2) => {
  switch (attack) {
    case ATTACK_TYPES.PUNCH:
      return getPunchArea(coords)
      break
    case ATTACK_TYPES.SWORD:
      return getSwordArea(coords)
      break
    case ATTACK_TYPES.FIREBALL:
      return getFireballArea(coords)
      break
    default:
      return [coords]
  }
}

export const getRangeBySight = (sightRange: number, coords: Vector2) => getSquareRange(coords, sightRange).filter(c => !c.equals(coords))

const getPunchArea = (coords: Vector2) => getCrossRange(coords, 1)
const getSwordArea = (coords: Vector2) => getSquareRange(coords, 2)
const getFireballArea = (coords: Vector2) => getSquareRange(coords, 200)
/**
 *  X
 * XOX
 *  X
 */
const getCrossRange = (coords: Vector2, range: number) => {
  const gridArea = []
  for (let x = -range; x <= range; x++) {
    for (let y = -range; y <= range; y++) {
      if(x === 0 || y === 0) {
        const hCoords = new Vector2(x, 0)
        const vCoords = new Vector2(0, y)
        gridArea.push(coords.clone().add(hCoords).add(vCoords))
      }
    }
  }

  return gridArea
}
/**
 * XXX
 * XOX
 * XXX
 */
const getSquareRange = (coords: Vector2, range: number) => {
  const gridArea = []
  for (let x = -range; x <= range; x++) {
    for (let y = -range; y <= range; y++) {
      const hCoords = new Vector2(x, 0)
      const vCoords = new Vector2(0, y)
      gridArea.push(coords.clone().add(hCoords).add(vCoords))
    }
  }

  return gridArea
}
